import { render, staticRenderFns } from "./MyNotifyDialog.vue?vue&type=template&id=65347bfa&scoped=true"
import script from "./MyNotifyDialog.vue?vue&type=script&lang=js"
export * from "./MyNotifyDialog.vue?vue&type=script&lang=js"
import style0 from "./MyNotifyDialog.vue?vue&type=style&index=0&id=65347bfa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65347bfa",
  null
  
)

export default component.exports